"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookieWithExpirationInMinutes = exports.setCookieWithExpirationInSeconds = exports.setCookieWithExpirationInDays = exports.setCookie = exports.getCookie = void 0;
function getCookie(key) {
    if (!(document && document.cookie)) {
        return null;
    }
    var foundCookie = document.cookie
        .split(';')
        .map(function (entry) { return entry.split('=', 2); })
        .filter(function (pair) { return pair[0].trim() === key; })[0];
    return foundCookie ? foundCookie[1] : null;
}
exports.getCookie = getCookie;
function setCookie(name, value, days) {
    setCookieWithExpirationInSeconds(name, value, days != undefined ? days * 24 * 60 * 60 : undefined);
}
exports.setCookie = setCookie;
function setCookieWithExpirationInDays(name, value, days) {
    setCookie(name, value, days);
}
exports.setCookieWithExpirationInDays = setCookieWithExpirationInDays;
function setCookieWithExpirationInSeconds(name, value, seconds) {
    if (!(document && document.cookie)) {
        return null;
    }
    var expires = '';
    seconds = value === null ? 0 : seconds;
    if (seconds != null) {
        var date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = "expires=" + date.toUTCString() + ";";
    }
    document.cookie = name + "=" + value + ";" + expires + "path=/";
}
exports.setCookieWithExpirationInSeconds = setCookieWithExpirationInSeconds;
function setCookieWithExpirationInMinutes(name, value, minutes) {
    setCookieWithExpirationInSeconds(name, value, minutes * 60);
}
exports.setCookieWithExpirationInMinutes = setCookieWithExpirationInMinutes;
//# sourceMappingURL=cookies.js.map